import { CustomFieldData } from "../../../skills_frameworks.types";

export const FIELD_ARRAY_NAME = "customFields";
export const ENTRIES_LIMIT = 4;
export const defaultCustomFieldRow: CustomFieldData = { customTypeId: null, values: [], customType: null };
